import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CompanyDetail, SuperAdminService } from '../services.service';


@Component({
  selector: 'app-superadmin-company-detail',
  templateUrl: './superadmin-company-detail.component.html',
  styleUrls: ['./superadmin-company-detail.component.css']
})
export class SuperadminCompanyDetailComponent implements OnInit {

  company?: CompanyDetail;
  loading = true;
  acting  = false;

  confirmAction: 'suspend' | 'reactivate' | null = null;

  // Track active state locally so UI updates immediately
  isActive = true;

  private avatarColors = [
    'linear-gradient(135deg, #1A1A2E, #2BB0A6)',
    'linear-gradient(135deg, #2BB0A6, #1F8F88)',
    'linear-gradient(135deg, #3498DB, #1A1A2E)',
    'linear-gradient(135deg, #E8A838, #C8891A)',
    'linear-gradient(135deg, #2ECC71, #1A9E4C)',
    'linear-gradient(135deg, #9B59B6, #6C3483)',
    'linear-gradient(135deg, #E74C3C, #C0392B)',
    'linear-gradient(135deg, #1ABC9C, #148F77)',
  ];

  constructor(
    private route: ActivatedRoute,
    private superAdminService: SuperAdminService
  ) {}

  ngOnInit(): void {
    const id = this.route.snapshot.paramMap.get('id')!;
    this.loadCompany(id);
  }

  loadCompany(id: string): void {
    this.loading = true;
    this.superAdminService.getCompany(id).subscribe({
      next: data => {
        this.company  = data;
        // Company is active if any admin/worker is active
        this.isActive = [
          ...data.admins,
          ...data.workers
        ].some(u => u.isActive);
        this.loading  = false;
      },
      error: () => { this.loading = false; }
    });
  }

  // ── Confirm modal ─────────────────────────────────────────

  openConfirm(action: 'suspend' | 'reactivate'): void {
    this.confirmAction = action;
  }

  closeConfirm(): void {
    this.confirmAction = null;
  }

  executeAction(): void {
    if (!this.company || !this.confirmAction) return;

    this.acting = true;

    const call = this.confirmAction === 'suspend'
      ? this.superAdminService.suspendCompany(this.company.id)
      : this.superAdminService.reactivateCompany(this.company.id);

    call.subscribe({
      next: () => {
        this.isActive      = this.confirmAction === 'reactivate';
        this.acting        = false;
        this.closeConfirm();
      },
      error: () => { this.acting = false; }
    });
  }

  // ── Helpers ───────────────────────────────────────────────

  getWorkerName(userId: string): string {
    if (!this.company) return 'Unknown';
    const all = [...this.company.workers, ...this.company.admins];
    return all.find(u => u.id === userId)?.fullName ?? 'Unknown';
  }

  getInitials(name: string): string {
    if (!name) return '?';
    const parts = name.trim().split(' ');
    return parts.length >= 2
      ? (parts[0][0] + parts[parts.length - 1][0]).toUpperCase()
      : name.slice(0, 2).toUpperCase();
  }

  getAvatarColor(userId: string): string {
    const code = userId?.charCodeAt(0) ?? 0;
    return this.avatarColors[code % this.avatarColors.length];
  }

  getStatusLabel(status: number): string {
    const labels: Record<number, string> = {
      0: 'Pending',
      1: 'In Progress',
      2: 'Completed',
      3: 'Failed'
    };
    return labels[status] ?? 'Unknown';
  }
}